<template>
    <div class="lg:col-span-9 min-h-26">
        <div class="flex flex-col w-full justify-between p-6">
            <h3>Order History</h3>
            <p>View all your previous orders.</p>
        </div>

        <ul class="w-full divide-y border-t">
            <li v-if="loading">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex items-center justify-center">
                        <font-awesome-icon icon="spinner" size="2x" pulse></font-awesome-icon>
                    </div>
                </div>
            </li>
            <li v-if="orders.length === 0 && !loading">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex items-center justify-center">
                        No orders found.
                    </div>
                </div>
            </li>
            <li class="cursor-pointer px-4 py-4 sm:px-6" v-for="cart in orders" :key="cart.id" @click="cartReceipt(cart)">
                <div class="flex items-center justify-between">
                    <p class="text-leonard-green truncate">Order # {{cart.order_number}}</p>
                    <div class="ml-2 flex-shrink-0 flex">
                        <span
                            v-if="cart.cancelled_at"
                            class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                        >Cancelled</span>
                        <span
                            v-if="!cart.cancelled_at"
                            class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                        >Completed</span>
                    </div>
                </div>
                <div class="mt-2 sm:flex sm:justify-between sm:space-x-2">
                    <p>
                        <small class="flex space-x-2 sm:space-x-3 items-center text-leonard-disclaimer">
                            <Attachment class="w-4"/>
                            <span>Invoice #{{cart.invoice_number}}</span>
                        </small>
                    </p>
                    <p>
                        <small class="flex space-x-2 sm:space-x-3 items-center text-leonard-disclaimer">
                            <CalendarClock class="w-4"/>
                            <time :datetime="cart.completed_at">{{cart.completed_at}}</time>
                        </small>
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

import Order from "../../classes/Order";
import Attachment from "../../components/icons/Attachment.vue";
import CalendarClock from "../../components/icons/CalendarClock.vue";

export default {
    components: {CalendarClock, Attachment},
    data() {
        return {
            Order: new Order(),
            orders: [],
            loading: false,
        };
    },

    created() {
        library.add(faSpinner);
    },

    mounted() {
        this.getOrderHistory();
    },

    methods: {
        getOrderHistory() {
            let self = this;
            let data = {
                user_id: this.$auth.user().details.id,
            };

            this.loading = true
            this.Order.getUserHistory(data).then(function (response) {
                self.loading = false
                self.orders = response.data;
            });
        },

        cartReceipt(cart) {
            this.$router.push({name: 'order-receipt', params: {cart_id: cart.id}})
        }
    },
};
</script>
